import { useEffect, useState } from 'react'
import { apiCompanies } from 'services/apiCompanies'

import { getParams } from 'utils/helpers'

export const useAppointmentConfirmation = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [success, setSuccess] = useState(false)

	const getToken = async () => {
		const { token } = await getParams()
		return token
	}

	const postToken = async () => {
		const token = await getToken()
		if (token) {
			setIsLoading(true)
			try {
				await apiCompanies.post('/appointments/confirm')
				setSuccess(true)
			} catch (error) {
				setIsLoading(true)
				setSuccess(false)
			} finally {
				setIsLoading(false)
			}
		}
	}

	useEffect(() => {
		document.title = 'Confirmacion de cita.'
		postToken()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		isLoading,
		success,
	}
}
